import React from 'react'
import Text, { DefaultFontProps } from 'library/atoms/Typography/Text'

const H4 = ({ children, ...other }: DefaultFontProps) => {
  return (
    <Text fontStyle="h4" as="h4" {...other}>
      {children}
    </Text>
  )
}

export default H4
